import { useMemo } from "react";
import FormControl from "@mui/material/FormControl";
import AutocompleteMui from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useGetCountries } from "../../hooks/useGetCountries";
import { isVersionUS } from "../../services/versionService";
import { sortCountries } from "../../helpers/countriesHelper";
import "./CountrySelect.css";

const CountrySelect = (props) => {
    const {
        label, control, name, error,
        disabled,
    } = props;
    const { countries, isLoading } = useGetCountries();
    const sortedCountries = sortCountries(countries, !isVersionUS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const countriesOptions = useMemo(() => sortedCountries.map((country) => ({ label: country.name, value: country.countryCode })), [sortedCountries.length]);

    return (
        <FormControl error={!!error} className={`autocomplete-field${disabled ? " field-disabled" : ""}`}>
            {label && <label htmlFor={name}>{label}</label>}
            <Controller
                render={({ field: { value, onChange, ...field } }) => (
                    <AutocompleteMui
                        id={name}
                        variant="outlined"
                        disabled={disabled || isLoading}
                        options={countriesOptions}
                        renderInput={(params) => <TextField {...params} error={!!error} helperText={null} />}
                        value={countriesOptions.find((option) => option.value === value) || null}
                        onChange={(e, newValue) => onChange(newValue.value)}
                        {...field}
                    />
                )}
                name={name}
                control={control}
            />
        </FormControl>
    );
};

export default CountrySelect;
